export default "__VITE_ASSET__9b673b8b__"